import React from 'react';
import SVG from 'react-inlinesvg';

const allsvg = {
  textlogo: require('../assets/img/db-logo-long.svg').default,
  circlelogo: require('../assets/img/duskbreakerslogo.svg').default,

  filter_icon: require('../assets/img/icons/filter.svg').default,

  arrow_up_icon: require('../assets/img/icons/arrow-up.svg').default,
  arrow_left_icon: require('../assets/img/icons/arrow-left-thin.svg').default,
  arrow_right_icon: require('../assets/img/icons/arrow-right-thin.svg').default,

  discord_icon: require('../assets/img/icons/social/discord.svg').default,
  instagram_icon: require('../assets/img/icons/social/instagram.svg').default,
  opensea_icon: require('../assets/img/icons/social/opensea.svg').default,
  twitch_icon: require('../assets/img/icons/social/twitch.svg').default,
  twitter_icon: require('../assets/img/icons/social/twitter.svg').default,
  youtube_icon: require('../assets/img/icons/social/youtube.svg').default,
  tiktok_icon: require('../assets/img/icons/social/tiktok.svg').default,

  default_icon: require('../assets/img/duskbreakerslogo.svg').default,
  background_icon: require('../assets/img/icons/background.svg').default,
  clothes_icon: require('../assets/img/icons/clothes.svg').default,
  drone_icon: require('../assets/img/icons/drone.svg').default,
  earring_icon: require('../assets/img/icons/earring.svg').default,
  eyebrows_icon: require('../assets/img/icons/eyebrows.svg').default,
  eyes_icon: require('../assets/img/icons/eyes.svg').default,
  face_aug_icon: require('../assets/img/icons/face-augments.svg').default,
  hair_icon: require('../assets/img/icons/hairstyle.svg').default,
  helmet_icon: require('../assets/img/icons/helmet.svg').default,
  mouth_icon: require('../assets/img/icons/mouth.svg').default,
  nose_icon: require('../assets/img/icons/nose.svg').default,
  partial_mask_icon: require('../assets/img/icons/partial-mask.svg').default,
  skin_icon: require('../assets/img/icons/skin-tone.svg').default,
  smartskin_icon: require('../assets/img/icons/smartskin.svg').default,
  tattoos_icon: require('../assets/img/icons/tattoos.svg').default,
  tentacles_icon: require('../assets/img/icons/tentacles.svg').default,
  canon_icon: require('../assets/img/icons/canon.svg').default,
  face_acc_icon: require('../assets/img/icons/face-accessories.svg').default,
  full_mask_icon: require('../assets/img/icons/full mask.svg').default,
};

const TraitIcon = ({ traitType }) => {
  switch (traitType) {
    case 'Canon':
      return <SVG className="gallery-icon" src={allsvg.canon_icon} />;
    case 'Clothes':
      return <SVG className="gallery-icon" src={allsvg.clothes_icon} />;
    case 'Partial Mask':
      return <SVG className="gallery-icon" src={allsvg.partial_mask_icon} />;
    case 'Drone':
      return <SVG className="gallery-icon" src={allsvg.drone_icon} />;
    case 'Earring':
      return <SVG className="gallery-icon" src={allsvg.earring_icon} />;
    case 'Eyebrows':
      return <SVG className="gallery-icon" src={allsvg.eyebrows_icon} />;
    case 'Nose':
      return <SVG className="gallery-icon" src={allsvg.nose_icon} />;
    case 'Hair':
      return <SVG className="gallery-icon" src={allsvg.hair_icon} />;
    case 'Eyes':
      return <SVG className="gallery-icon" src={allsvg.eyes_icon} />;
    case 'Mouth':
      return <SVG className="gallery-icon" src={allsvg.mouth_icon} />;
    case 'Skin Tone':
      return <SVG className="gallery-icon" src={allsvg.skin_icon} />;
    case 'Background':
      return <SVG className="gallery-icon" src={allsvg.background_icon} />;
    case 'Face Accessories':
      return <SVG className="gallery-icon" src={allsvg.face_acc_icon} />;
    case 'Full Helmet':
      return <SVG className="gallery-icon" src={allsvg.helmet_icon} />;
    case 'Face Augments':
      return <SVG className="gallery-icon" src={allsvg.face_aug_icon} />;
    case 'SmartSkin':
      return <SVG className="gallery-icon" src={allsvg.smartskin_icon} />;
    case 'Tattoos':
      return <SVG className="gallery-icon" src={allsvg.tattoos_icon} />;
    case 'Tentacles':
      return <SVG className="gallery-icon" src={allsvg.tentacles_icon} />;
    case 'Full Mask':
      return <SVG className="gallery-icon" src={allsvg.full_mask_icon} />;

    default:
      return <span></span>;
  }
};

export { allsvg, TraitIcon };
